import { render, staticRenderFns } from "./P3InventoryCard.vue?vue&type=template&id=5c78d34d"
import script from "./P3InventoryCard.vue?vue&type=script&lang=js"
export * from "./P3InventoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports